"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var model_converters_1 = require("../converter/model-converters");
var ReversedUartSettingsConverter = /** @class */ (function () {
    function ReversedUartSettingsConverter() {
        this.converter = new model_converters_1.UartSettingsConverter();
    }
    ReversedUartSettingsConverter.prototype.decode = function (data) {
        data = data.slice(0, 8).reverse();
        return this.converter.decode(data);
    };
    ReversedUartSettingsConverter.prototype.encode = function (settings) {
        return this.converter.encode(settings).reverse();
    };
    return ReversedUartSettingsConverter;
}());
exports.ReversedUartSettingsConverter = ReversedUartSettingsConverter;
